import React from 'react'
import Header from './Components/Header'
import { useState } from 'react'
import TodosGroup from './Components/TodosGroup'
import AddTodo from './Components/AddTodo'
import Test from './Pages/Test'

export default function App() {

  const [theme, settheme] = useState('light')
  const [TodoData, SetTodoData] = useState([])
  let [SNO, setSNO] = useState(0);

  //Handel functions
  const handeltheme = (e) => {
    e.preventDefault();
    if (theme === "dark") {
      settheme("light")
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black";
    }
    else {
      settheme("dark")
      document.body.style.backgroundColor = "rgb(17 24 39)";
      document.body.style.color = "white";
    }
  }
  const AddTodoFunc = (Title, Desc) => {
    setSNO(SNO += 1);
    SetTodoData([{ sno: SNO, title: Title, description: Desc }, ...TodoData])
  }
  const handeldelete = (snopara) => {

    SetTodoData(TodoData.filter((e) => {
      return e.sno !== snopara;
    }))
  }

  return (
    <>

      <Header theme={theme} onevent={handeltheme}></Header>
      <AddTodo AddTodoFunc={AddTodoFunc} theme={theme} />
      <TodosGroup theme={theme} TodoData={TodoData} handeldelete={handeldelete} />


    </>
  )
}
